import React, { useCallback, useEffect, useRef, useState } from 'react';
import _ from 'lodash';
import { GoogleMap, Marker, Polygon, useJsApiLoader, InfoWindow, HeatmapLayer } from "@react-google-maps/api"

import './DynamicMap.css';
import { FormControl, InputGroup, Panel, Row, Table } from 'react-bootstrap';

import { useMlsMetricsStore } from '../../../store/providers/MlsMetrics';

import Spinner from '../../Spinner/Spinner';
import CurrencyFormat from 'react-currency-format';
import CheckboxInput from '../../CheckboxInput/CheckboxInput';
import InputCollectionInline from '../../InputCollection/InputCollectionInline';
import DynamicMapLegend from './DynamicMapLegend';
import CheckboxInputControlled from '../../CheckboxInput/CheckboxInputControlled';

const libraries =  ['visualization','geometry', 'places'];

function DynamicMap(props){
    const { selectZipMetrics, data: zipCodeMetricsData } = useMlsMetricsStore();
    
    const [isPageLoaded, setIsPageLoaded] = useState(false);
    const [isBusy, setIsBusy] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [zipsSelected, setZipsSelected] = useState([]);
    const [zipInfo, setZipInfo] = useState();
    const [zipStats, setZipStats] = useState();
    const [zipStatsAll, setZipStatsAll] = useState([]);
    const [totals, setTotals] = useState();

    const [mapState, setMapState] = useState();
    const [mapPolygons, setMapPolygons] = useState([]);
    const [officeMarkers, setOfficeMarkers] = useState([]);
    const [selectedCenter, setSelectedCenter] = useState(null);
    const [selectedHeatMapCenter, setSelectedHeatMapCenter] = useState(null);

    const gMapRef = useRef(null);
    const [showZipcodeMarkers, setShowZipcodeMarkers] = useState(false);
    const [hideZipCodesNotSelected, setHideZipCodesNotSelected] = useState(false);
    const [heatMapPointsAll, setHeatMapPointsAll] = useState([]);
    const [heatMapPointsHS, setHeatMapPointsHS] = useState([]);
    const [heatMapRadius, setHeatMapRadius] = useState(35);
    const [displayPrivateOffices, setDisplayPrivateOffices] = useState(false);

    const [selectedOption, setSelectedOption] = useState(null);

    const handleSingleSelectChange = (id, isChecked) => {
        if (isChecked) {
          setSelectedOption(id); // select this one
        } else {
          setSelectedOption(null); // unselect if clicked again
        }
      };

    const onLoad = useCallback(function callback(map) {
        setMapState(map)
    }, [])
    const onUnmount = useCallback(function callback() {
        setMapState(null)
    }, [])

    const onError = useCallback(function callback(map) {
        setMapState(null)
        onLoad(map);
    }, [onLoad])

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: 'AIzaSyCiughxCc4WyXtsqGr--xXvU0dOrniUvyU',
        libraries: libraries,
    });


    const optionColors = [
        'rgba(245, 40, 145, 0.7)',
        'rgba(174, 39, 245, 0.7)',
        'rgba(39, 54, 245, 0.7)',
        'rgba(39, 187, 245, 0.7)',
        'rgba(39, 245, 213, 0.7)',
        'rgba(39, 245, 84, 0.7)',
        'rgba(217, 245, 39, 0.7)',
        'rgba(245, 127, 39, 0.7)',
        'rgba(245, 39, 39, 0.7)',
        'rgba(143, 6, 113, 0.7)',
        'rgba(62, 6, 143, 0.7)',
        'rgba(6, 36, 143, 0.7)',
        'rgba(6, 130, 143, 0.7)',
        'rgba(6, 143, 47, 0.7)',
        'rgba(143, 138, 6, 0.7)',
        'rgba(143, 36, 6, 0.7)',
        'rgba(255, 0, 0, 0.7)',
        'rgba(255, 0, 231, 0.7)',
        'rgba(77, 0, 255, 0.7)',
        'rgba(0, 252, 255, 0.7)',
        'rgba(0, 255, 35, 0.7)',
        'rgba(242, 255, 0, 0.7)',
        'rgba(255, 167, 0, 0.7)',
        'rgba(245, 40, 145, 0.4)',
        'rgba(174, 39, 245, 0.4)',
        'rgba(39, 54, 245, 0.4)',
        'rgba(39, 187, 245, 0.4)',
        'rgba(39, 245, 213, 0.4)',
        'rgba(39, 245, 84, 0.4)',
        'rgba(217, 245, 39, 0.4)',
        'rgba(245, 127, 39, 0.4)',
        'rgba(245, 39, 39, 0.4)',
        'rgba(143, 6, 113, 0.4)',
        'rgba(62, 6, 143, 0.4)',
        'rgba(6, 36, 143, 0.4)',
        'rgba(6, 130, 143, 0.4)',
        'rgba(6, 143, 47, 0.4)',
        'rgba(143, 138, 6, 0.4)',
        'rgba(143, 36, 6, 0.4)',
        'rgba(255, 0, 0, 0.4)',
        'rgba(255, 0, 231, 0.4)',
        'rgba(77, 0, 255, 0.4)',
        'rgba(0, 252, 255, 0.4)',
        'rgba(0, 255, 35, 0.4)',
        'rgba(242, 255, 0, 0.4)',
        'rgba(255, 167, 0, 0.4)'
    ]

    const options = {
        fillColor: 'rgba(232, 200, 240, 0.25)',
        fillOpacity: 10,
        strokeColor: 'rgba(66, 66, 253, 0.9)',
        strokeOpacity: 1,
        strokeWeight: 1,
        clickable: true,
        draggable: false,
        editable: false,
        geodesic: false,
        zIndex: 9
    }

    const optionsOutlined = {
        fillColor: 'rgba(232, 200, 240, 0)',
        fillOpacity: 0,
        strokeColor: 'rgba(66, 66, 253, 0.9)',
        strokeOpacity: 1,
        strokeWeight: 1,
        clickable: true,
        draggable: false,
        editable: false,
        geodesic: false,
        zIndex: 9
    }

    const optionsMarketing = {
        fillColor: 'rgba(212, 170, 220, 0.8)',
        fillOpacity: 10,
        strokeColor: 'rgba(66, 66, 253, 0.9)',
        strokeOpacity: 1,
        strokeWeight: 1,
        clickable: true,
        draggable: false,
        editable: false,
        geodesic: false,
        zIndex: 9
    }

    const optionsCorp = {
        fillColor: 'rgba(255, 0, 0, 0.7)',
        fillOpacity: 10,
        strokeColor: 'rgba(66, 66, 253, 0.9)',
        strokeOpacity: 1,
        strokeWeight: 1,
        clickable: true,
        draggable: false,
        editable: false,
        geodesic: false,
        zIndex: 9
    }

    const optionsCorpRofr = {
        fillColor: 'rgba(255, 0, 0, 0.5)',
        fillOpacity: 10,
        strokeColor: 'rgba(66, 66, 253, 0.9)',
        strokeOpacity: 1,
        strokeWeight: 1,
        clickable: true,
        draggable: false,
        editable: false,
        geodesic: false,
        zIndex: 9
    }

    const optionsSelected = {
        fillColor: 'rgba(232, 230, 133, 0.8)',
        fillOpacity: 10,
        strokeColor: 'rgba(66, 66, 253, 0.9)',
        strokeOpacity: 1,
        strokeWeight: 1,
        clickable: true,
        draggable: false,
        editable: false,
        geodesic: false,
        zIndex: 9
    }

    const optionsCurrent = {
        fillColor: 'rgba(232, 230, 133, 0.9)',
        fillOpacity: 10,
        strokeColor: 'rgba(66, 66, 253, 0.9)',
        strokeOpacity: 1,
        strokeWeight: 1,
        clickable: true,
        draggable: false,
        editable: false,
        geodesic: false,
        zIndex: 9
    }

    const optionsNonCorp = {
        fillColor: 'rgba(106, 90, 205, 0.8)',
        fillOpacity: 10,
        strokeColor: 'rgba(66, 66, 253, 0.9)',
        strokeOpacity: 1,
        strokeWeight: 1,
        clickable: true,
        draggable: false,
        editable: false,
        geodesic: false,
        zIndex: 9
    }

    const optionsNonCorpRofr = {
        fillColor: 'rgba(106, 90, 205, 0.5)',
        fillOpacity: 10,
        strokeColor: 'rgba(66, 66, 253, 0.9)',
        strokeOpacity: 1,
        strokeWeight: 1,
        clickable: true,
        draggable: false,
        editable: false,
        geodesic: false,
        zIndex: 9
    }

    let colorTerritories = [];

    var gradient = [
        "rgba(0, 0, 255, 0)",
        "rgba(0, 0, 255, 1)",
        "rgba(0, 0, 223, 1)",
        "rgba(0, 0, 191, 1)",
        "rgba(0, 0, 159, 1)",
        "rgba(0, 0, 127, 1)",

        "rgba(239, 230, 120, 1)",
        "rgba(239, 230, 110, 1)",
        "rgba(239, 230, 100, 1)",
        "rgba(240, 229, 94, 1)",
        "rgba(240, 229, 78, 1)",
        "rgba(243, 230, 62, 1)",
        "rgba(250, 230, 40, 1)",
        "rgba(255, 236, 0, 1)",

        "rgba(255, 176, 0, 1)",
        "rgba(255, 137, 0, 1)",
        "rgba(255, 97, 0, 1)",
       // "rgba(255, 35, 0, 1)",
        "rgba(255, 0, 0, 1)",
    ]

    const exampleMapStyles = [
        {
          elementType: "geometry",
          stylers: [{ color: "#f5f5f5" }]
        },
        {
          elementType: "labels.text.fill",
          stylers: [{ color: "#424242" }]
        },
        {
          elementType: "labels.text.stroke",
          stylers: [{ color: "#ffffff" }]
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [{ color: "#cccccc" }]
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [{ color: "#a0a0a0" }]
        },
        {
          featureType: "poi",
          elementType: "geometry",
          stylers: [{ color: "#dddddd" }]
        },
        {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [{ color: "#b0b0b0" }]
        },
        {
          featureType: "road.highway",
          elementType: "labels.text.fill",
          stylers: [{ color: "#333333" }]
        },
        {
          featureType: "administrative",
          elementType: "labels.text.fill",
          stylers: [{ color: "#444444" }]
        }
    ];

    const parseMapData =(mapStuff, officeData, statistics, map) => {
        if(mapStuff){
            let polyArray = [];
            let polyCenterArray = [];
            let markerArray = [];
            let officeArray = [];

            if(!hideZipCodesNotSelected){
                setZipInfo();
                setZipStats();
                setZipStatsAll([]);
                setZipsSelected([]);
            }

            officeData.forEach((o) => {
                if (o.active === true) {
                    if (displayPrivateOffices) {
                        officeArray.push({ lat: o.latitude, lng: o.longitude, name: o.name, type: o.officeTypeName, instance: o.franchiseInstance, fullAddress: o.fullAddress });
                    } else if (!displayPrivateOffices && o.private === false) {
                        officeArray.push({ lat: o.latitude, lng: o.longitude, name: o.name, type: o.officeTypeName, instance: o.franchiseInstance, fullAddress: o.fullAddress });
                    }
                }
                setSelectedCenter(null);
            });

            mapStuff.forEach((m) => {
                if(hideZipCodesNotSelected === true && zipsSelected.length > 0){
                    if( m.PolygonBoundaries && zipsSelected.some(item => item === m.Zipcode)) {
                        m.PolygonBoundaries.forEach((pb) => {
                            polyCenterArray.push(pb.centroid);
                            polyArray.push({Zipcode: m.Zipcode, POLYGON: pb.POLYGON, centroid: pb.centroid, TerritoryTypeId: m.TerritoryTypeId, Franchise: m.Franchise, BranchOffice: m.BranchOffice});
                        });
                    }
                } else {

                    if(props.selectedFranchises.length > 0 && props.selectedFranchises.some(item => item.id === m.Franchise.Id)){
                        if( m.PolygonBoundaries) {
                            m.PolygonBoundaries.forEach((pb) => {
                                polyCenterArray.push(pb.centroid);
                                polyArray.push({Zipcode: m.Zipcode, POLYGON: pb.POLYGON, centroid: pb.centroid, TerritoryTypeId: m.TerritoryTypeId, Franchise: m.Franchise, BranchOffice: m.BranchOffice});
                            });
                        }
                    }

                    if(props.selectedFranchises.length === 0){
                        if( m.PolygonBoundaries) {
                            m.PolygonBoundaries.forEach((pb) => {
                                polyCenterArray.push(pb.centroid);
                                polyArray.push({Zipcode: m.Zipcode, POLYGON: pb.POLYGON, centroid: pb.centroid, TerritoryTypeId: m.TerritoryTypeId, Franchise: m.Franchise, BranchOffice: m.BranchOffice});
                            });
                        }
                    }           
                }     
            })

            if(!showZipcodeMarkers && !selectedOption ){
                setMapBounds(map, polyCenterArray, markerArray);
            }

            if (statistics && typeof(window.google) != "undefined"){
                let heatMapBoundsHS = [];
                let heatMapBoundsAll = [];

                if(selectedOption && (selectedOption === 'heatMapAllAgents' || selectedOption === 'heatMapAllZipcodeAgents')) {
                    statistics.forEach((s) => {
                        if(s && s.Centroid){
                            const lat = eval(s.Centroid)[0];
                            const lng = eval(s.Centroid)[1];
                            const weight = s.AllAgentCount;
                            heatMapBoundsAll.push({location: new window.google.maps.LatLng(lat, lng), weight: weight});
                        }  
                    });
                } 
                if(selectedOption && (selectedOption === 'heatMapHomeSmartAgents' || selectedOption === 'heatMapShadedHomeSmartAgents')) {
                    statistics.forEach((s) => {
                        if(s && s.Centroid){
                            const lat = eval(s.Centroid)[0];
                            const lng = eval(s.Centroid)[1];
                            const weight = s.InHouseAgentCount;
                            heatMapBoundsHS.push({location: new window.google.maps.LatLng(lat, lng), weight: weight});
                        }                          
                    });
                }
                setHeatMapPointsHS(heatMapBoundsHS);;
                setHeatMapPointsAll(heatMapBoundsAll);;
            }

            setMapPolygons(polyArray);
            setOfficeMarkers(officeArray);
        }
    }
    
    const setMapBounds = (map, polygons, markers) => {      
        if (typeof window.google !== "undefined") {
            const bounds = new window.google.maps.LatLngBounds();
            if (polygons && polygons.length) {
                polygons.forEach((poly) => {
                    const latLng = new window.google.maps.LatLng(poly[0], poly[1]);
                    bounds.extend(latLng);                            
                }); 
            }
            map.fitBounds(bounds);
        }
    };

    const onPolyClick = (poly, option) => {  
        if (zipsSelected && zipsSelected.some(item => poly.Zipcode === item)){
            setZipStats();
            setZipInfo();

            let filteredArray = zipsSelected.filter(item => item !== poly.Zipcode)
            setZipsSelected(filteredArray);

            let filteredZipMetricsArray = zipStatsAll.filter(item => item.zip !== poly.Zipcode)
            setZipStatsAll(filteredZipMetricsArray);

        } else {
            setZipInfo(poly);
            setZipsSelected([...zipsSelected, poly.Zipcode]);
            selectZipMetrics({zipcode: poly.Zipcode});
        }
        setSelectedCenter(null);
    }

    const onPolyHeatClick = (poly, option) => {  
        if (zipsSelected && zipsSelected.some(item => poly.Zipcode === item)){
            setZipStats();
            setZipInfo();

            let filteredArray = zipsSelected.filter(item => item !== poly.Zipcode)
            setZipsSelected(filteredArray);

            let filteredZipMetricsArray = zipStatsAll.filter(item => item.zip !== poly.Zipcode)
            setZipStatsAll(filteredZipMetricsArray);

        } else {
            setZipInfo(poly);
            setZipsSelected([...zipsSelected, poly.Zipcode]);
            selectZipMetrics({zipcode: poly.Zipcode});
        }

        if(props.statistics){
            props.statistics.forEach((s) => {
                if(s && s.ZipCode === poly.Zipcode){
                    const lat = eval(s.Centroid)[0];
                    const lng = eval(s.Centroid)[1];
                    setSelectedHeatMapCenter({location: new window.google.maps.LatLng(lat, lng),lat: lat, lng: lng, name: s.ZipCode, state: s.StateId, agentCountAll: s.AllAgentCount, agentCountHS: s.InHouseAgentCount});
                }  
            });
        }
        setSelectedCenter(null);
    }

    const getGreenShade = (count, min, max) => {
        if (count === 0) return 'hsla(120, 100%, 50%, 0)'; // Fully transparent for zero
    
        const logMin = Math.log(1 + Math.max(min, 1));
        const logMax = Math.log(1 + max);
        const logCount = Math.log(1 + count);
        const ratio = (logCount - logMin) / (logMax - logMin);
    
        const lightness = 70 - ratio * 50; // Darker baseline
        const alpha = 0.2 + ratio * 0.6;   // Max alpha = 0.8
    
        return `hsla(120, 100%, ${lightness}%, ${alpha})`;
    };

    let minAgentCount = Infinity;
    let maxAgentCount = -Infinity;
    let minAgentHSCount = Infinity;
    let maxAgentHSCount = -Infinity;
    
    if (props.statistics) {
        props.statistics.forEach(s => {
            if (s.AllAgentCount != null) {
                minAgentCount = Math.min(minAgentCount, s.AllAgentCount);
                maxAgentCount = Math.max(maxAgentCount, s.AllAgentCount);
            }
            if (s.InHouseAgentCount != null) {
                minAgentHSCount = Math.min(minAgentHSCount, s.InHouseAgentCount);
                maxAgentHSCount = Math.max(maxAgentHSCount, s.InHouseAgentCount);
            }
        });    
    }

    useEffect(() => {
        if (!_.isEmpty(zipCodeMetricsData)) {
            if (zipCodeMetricsData.scope === 'selectzip' && zipCodeMetricsData.status === 'success') {
                if (zipCodeMetricsData.body && zipCodeMetricsData.body[0]) {
                    setZipStats(zipCodeMetricsData.body[0]);
    
                    setZipStatsAll(prevStats => {
                        if (!prevStats.some(item => item.zip === zipCodeMetricsData.body[0].zip)) {
                            return [...prevStats, zipCodeMetricsData.body[0]];
                        }
                        return prevStats;
                    });
                }
            }
    
            setIsBusy(zipCodeMetricsData.status === 'processing');
        }
    }, [props, zipCodeMetricsData]); 

    useEffect(() => {
        if (props.officeData && props.mapData && mapState && props.statistics) {
            setErrorMessage('');
            parseMapData(props.mapData, props.officeData, props.statistics, mapState); 
        }

    }, [props.mapData, props.statistics, mapState, showZipcodeMarkers, hideZipCodesNotSelected, selectedOption, displayPrivateOffices]);

    useEffect(() => {
        props.disableSubmission(hideZipCodesNotSelected);   
    }, [hideZipCodesNotSelected]);

    useEffect(() => {
        if(zipStatsAll && !_.isEmpty(zipStatsAll)){
            let totalAgentCount = 0;
            let totalSellingUnits = 0;
            let totalSellingVolume = 0;
            let totalSellingAveragePrice = 0;
            let totalRows = 0;

            zipStatsAll.forEach((row, key) => {
                if( zipsSelected.includes(row.zip)){
                    totalRows++;
                    totalAgentCount += parseInt(row.Agent_Count);
                    totalSellingUnits += parseInt(row.Selling_Units);
                    totalSellingVolume += parseInt(row.Selling_Volume);
                    totalSellingAveragePrice += parseInt(row.Selling_Average_Price);
                }
            });

            totalSellingAveragePrice = (parseInt(totalRows) != 0) ? parseInt(totalSellingAveragePrice)/parseInt(totalRows) : 'n/a';
            setTotals({totalAgentCount: totalAgentCount, totalSellingUnits: totalSellingUnits, totalSellingVolume: totalSellingVolume, totalSellingAveragePrice: totalSellingAveragePrice, totalRows: totalRows })
        } else {
            setTotals();
        }
    }, [zipStatsAll, zipsSelected]);
    
    useEffect(() => {
        if(!isPageLoaded){
            setErrorMessage('');
            setMapPolygons([]);
            setOfficeMarkers([]);
            setZipInfo();
            setZipStats();
            setZipStatsAll([]);
            setZipsSelected([]);
        } else {
            setIsPageLoaded(true);
        }
    }, [isPageLoaded])

    return (
        <>
        <>
            {errorMessage &&
                <Row><div className="col-md-12">{errorMessage}</div></Row>
            }
            <Row>     
                <div className="col-md-12" style={{ display: 'flex', alignItems: 'baseline', marginBottom: '1rem' }}>
                    <span style={{marginRight: '2rem'}} ><CheckboxInput style={{display: 'inline', marginRight: '1rem'}} id="displayPrivateOffices" value={displayPrivateOffices} changed={(id, value) => { setDisplayPrivateOffices(!value);}} labelText="Private Offices" disabled={isBusy} /></span>
                    <span style={{marginRight: '2rem'}} ><CheckboxInput style={{display: 'inline', marginRight: '1rem'}} id="showZipcodes" value={showZipcodeMarkers} changed={(id, value) => { setShowZipcodeMarkers(!value);}} labelText="Zip Codes" disabled={isBusy} /></span>
                    <span style={{marginRight: '2rem'}} ><CheckboxInput style={{display: 'inline', marginRight: '1rem'}} id="hideZipCodesNotSelected" value={hideZipCodesNotSelected} changed={(id, value) => { setHideZipCodesNotSelected(!value);}} labelText="Selected Zip Codes" disabled={zipsSelected.length === 0 || isBusy} /></span>
                    <span style={{ marginRight: '2rem' }}>
                        <CheckboxInputControlled
                            id="colorCodeTerritories"
                            value={selectedOption === 'colorCodeTerritories'}
                            changed={handleSingleSelectChange}
                            labelText="Color Code Instances"
                            disabled={isBusy}
                        />
                    </span>
                    <span style={{ marginRight: '2rem' }}>
                        <CheckboxInputControlled
                            id="heatMapAllZipcodeAgents"
                            value={selectedOption === 'heatMapAllZipcodeAgents'}
                            changed={handleSingleSelectChange}
                            labelText="Shaded Heatmap - All"
                            disabled={isBusy}
                        />
                    </span>
                    <span style={{ marginRight: '2rem' }}>
                        <CheckboxInputControlled
                            id="heatMapShadedHomeSmartAgents"
                            value={selectedOption === 'heatMapShadedHomeSmartAgents'}
                            changed={handleSingleSelectChange}
                            labelText="Shaded Heatmap - HomeSmart"
                            disabled={isBusy}
                        />
                    </span>
                    <span style={{ marginRight: '2rem' }}>
                        <CheckboxInputControlled
                            id="heatMapAllAgents"
                            value={selectedOption === 'heatMapAllAgents'}
                            changed={handleSingleSelectChange}
                            labelText="Traditional Heatmap - All"
                            disabled={isBusy}
                        />
                    </span>
                    <span style={{ marginRight: '2rem' }}>
                        <CheckboxInputControlled
                            id="heatMapHomeSmartAgents"
                            value={selectedOption === 'heatMapHomeSmartAgents'}
                            changed={handleSingleSelectChange}
                            labelText="Traditional Heatmap - HomeSmart"
                            disabled={isBusy}
                        />
                    </span>
                    <span style={{marginRight: '1rem'}} >
                        <InputCollectionInline labelText="HeatMap Radius">
                            <InputGroup style={{display: 'inline-flex'}}>
                                <FormControl 
                                    style={{ display: 'inline', width: '70px', marginLeft: '1rem'}}
                                    id="heatMapRadius" 
                                    type="number" 
                                    onChange={(e) => setHeatMapRadius(e.target.value)} 
                                    defaultValue={heatMapRadius} 
                                    disabled={isBusy} 
                                />
                            </InputGroup>
                        </InputCollectionInline>
                    </span>
                </div> 
            </Row>
            <Row>                
                <div id="heatmap-territories" className={zipStatsAll && !_.isEmpty(zipStatsAll) ? "col-md-12" : "col-md-12"}>
                    <div className="google-map">
                        {isLoaded && <GoogleMap
                            ref={gMapRef} 
                            options={{
                                styles: exampleMapStyles,
                               //mapTypeId: (heatMapAllAgents || heatMapHomeSmartAgents) ? "satellite" : "roadmap",
                                minZoom:4,
                                gestureHandling: 'greedy',
                                maxZoom:18
                            }}
                            onError={onError}
                            onLoad={onLoad}
                            onUnmount={onUnmount}
                            onClick={(e) => setSelectedCenter(null)}
                            id='google-map'
                            key='google-map'
                            >
                            {selectedOption && selectedOption === 'heatMapAllZipcodeAgents' && (maxAgentCount > 0) && 
                                <DynamicMapLegend
                                    min={minAgentCount}
                                    max={maxAgentCount}
                                    getGreenShade={getGreenShade}
                                />
                            }
                            {selectedOption && selectedOption === 'heatMapShadedHomeSmartAgents' && (maxAgentHSCount > 0) && 
                                <DynamicMapLegend
                                    min={minAgentHSCount}
                                    max={maxAgentHSCount}
                                    getGreenShade={getGreenShade}
                                />
                            }
                            {heatMapPointsHS && selectedOption && selectedOption === 'heatMapHomeSmartAgents' && 
                                <HeatmapLayer
                                    options={{
                                        // maxIntensity: 300,
                                        gradient: gradient,
                                        radius: heatMapRadius,
                                        opacity: .8,
                                     }}
                                    data={heatMapPointsHS}
                                />
                            }
                            {heatMapPointsAll && selectedOption && selectedOption === 'heatMapAllAgents' && 
                                <HeatmapLayer
                                    options={{
                                        // maxIntensity: 1000,
                                        gradient: gradient,
                                        radius: heatMapRadius,
                                        opacity: .8,
                                     }}
                                    data={heatMapPointsAll}
                                />
                            }

                            {selectedCenter && (
                                <InfoWindow
                                    key={'infowindow_'+selectedCenter.lat}
                                    id={'infowindow_'+selectedCenter.lat}
                                    onCloseClick={() => {
                                        setSelectedCenter(null);
                                    }}
                                    position={{
                                        lat: selectedCenter.lat,
                                        lng: selectedCenter.lng
                                    }}
                                    >
                                    <div style={{ minWidth: '200px', maxWidth: '300px' }}>
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            fontWeight: 'bold',
                                            borderBottom: '1px solid #ccc',
                                            paddingBottom: '1rem',
                                            marginBottom: '1rem'
                                        }}>
                                            <span>{selectedCenter.name}</span>
                                            <button onClick={() => setSelectedCenter(null)} style={{
                                                background: 'none',
                                                border: 'none',
                                                fontSize: '2rem',
                                                cursor: 'pointer',
                                                lineHeight: '1'
                                            }}>×</button>
                                        </div>
                                        <p>{selectedCenter.name} ({selectedCenter.instance})</p>
                                        <p style={{ fontWeight: 'bold', textAlign: 'center' }}><span>{selectedCenter.fullAddress}</span></p>
                                    </div>
                                </InfoWindow>
                            )}

                            {selectedHeatMapCenter && (
                                <InfoWindow
                                key={'infowindow_' + selectedHeatMapCenter.lat}
                                onCloseClick={() => setSelectedHeatMapCenter(null)}
                                options={{ disableAutoPan: false }}
                                    position={{
                                        lat: selectedHeatMapCenter.lat,
                                        lng: selectedHeatMapCenter.lng
                                    }}
                                    >
                                    <div style={{ minWidth: '200px', maxWidth: '300px' }}>
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            fontWeight: 'bold',
                                            borderBottom: '1px solid #ccc',
                                            paddingBottom: '1rem',
                                            marginBottom: '1rem'
                                        }}>
                                            <span>{selectedHeatMapCenter.name}</span>
                                            <button onClick={() => setSelectedHeatMapCenter(null)} style={{
                                                background: 'none',
                                                border: 'none',
                                                fontSize: '2rem',
                                                cursor: 'pointer',
                                                lineHeight: '1'
                                            }}>×</button>
                                        </div>

                                        {((selectedOption && (selectedOption === 'heatMapAllAgents' || selectedOption === 'heatMapAllZipcodeAgents' || selectedOption === 'heatMapHomeSmartAgents' || selectedOption === 'heatMapShadedHomeSmartAgents')) && (zipStats && selectedHeatMapCenter.name === zipStats.zip)) &&
                                            <>
                                            {(selectedOption && (selectedOption === 'heatMapHomeSmartAgents' || selectedOption === 'heatMapShadedHomeSmartAgents')) &&
                                                <p><strong>HS Agent Count</strong>: {selectedHeatMapCenter.agentCountHS}<br/><small>(Based on Agent Address Zip Code)</small></p>
                                            }
                                            <p><strong>All Agent Count</strong>:{zipStats && zipStats.Agent_Count ? zipStats.Agent_Count : null}<br/><small>(Based on Office Zip Code)</small></p>
                                            <p style={{paddingTop:'1rem',borderTop: '1px solid #ccc'}}><strong>ALL AGENT STATISTICS</strong></p>
                                            <p><strong>Listing Avg Price</strong>: {zipStats && zipStats.Listing_Average_Price ? <CurrencyFormat value={zipStats.Listing_Average_Price || 0.00} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true}/> : null}</p>
                                            <p><strong>Listing Units</strong>: {zipStats && zipStats.Listing_Units ? zipStats.Listing_Units : null}</p>
                                            <p><strong>Listing Volume</strong>: {zipStats && zipStats.Listing_Volume ? <CurrencyFormat value={zipStats.Listing_Volume || 0.00} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true}/> : null}</p>
                                            <p><strong>Selling Avg Price</strong>: {zipStats && zipStats.Selling_Average_Price ? <CurrencyFormat value={zipStats.Selling_Average_Price || 0.00} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true}/> : null}</p>
                                            <p><strong>Selling Units</strong>: {zipStats && zipStats.Selling_Units ? zipStats.Selling_Units : null}</p>
                                            <p><strong>Selling Volume</strong>: {zipStats && zipStats.Selling_Volume ? <CurrencyFormat value={zipStats.Selling_Volume || 0.00} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true}/> : null}</p>
                                            </>
                                        }
                                        
                                        {isBusy &&
                                            <Spinner text="Loading..." />
                                        }
                                        
                                    </div>
                                </InfoWindow>
                            )}

                            {!hideZipCodesNotSelected && officeMarkers &&
                                officeMarkers.map((option, i) => {
                                    var pinSVGHole = "M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z";
                                    return <Marker 
                                            id={'marker_office_'+i+'_'+option.Zipcode}
                                            key={'marker_office_'+i+'_'+option.Zipcode}
                                            position={{ lat: option.lat, lng: option.lng}}
                                            onClick={() => {
                                                setSelectedCenter(option);
                                            }}
                                            icon= {{
                                                path: pinSVGHole,
                                                scale: 1.6,
                                                anchor: new window.google.maps.Point(12,15),
                                                strokeWeight: 0.5,
                                                strokeColor: '#fff',
                                                strokeOpacity: 1,
                                                fillColor: '#0e0e6a',
                                                fillOpacity: 0.75,
                                            }}
                                        />
                                })
                            }

                            {mapState && mapPolygons && mapPolygons.length > 0 && 
                                mapPolygons.map((option, indexb) => {
                            
                                    let styleOptions = options;
                                    if(option.Franchise && option.Franchise.CorporateOwned === true){
                                        if(option.TerritoryTypeId && option.TerritoryTypeId === 3){
                                            styleOptions = optionsCorpRofr
                                        } else {
                                            styleOptions = optionsCorp
                                        }
                                    }
                                    if(option.Franchise && option.Franchise.CorporateOwned === false){
                                        if(option.TerritoryTypeId && option.TerritoryTypeId === 3){
                                            styleOptions = optionsNonCorpRofr
                                        } else {
                                            styleOptions = optionsNonCorp
                                        }
                                    }
                                    if(option.TerritoryTypeId && option.TerritoryTypeId === 2){
                                        styleOptions = optionsMarketing
                                    }

                                    if(selectedOption && selectedOption === 'colorCodeTerritories' && option.Franchise.Id) {
                                        let colorTerritory = '';
                                        if(!colorTerritories.some(item => option.Franchise.Id === item.Id)){
                                            colorTerritories.push({Id: option.Franchise.Id, Name: option.Franchise.Name + ' (' + option.Franchise.InternalId + ')', Color: optionColors[colorTerritories.length + 1]});
                                            colorTerritory = optionColors[colorTerritories.length + 1];
                                        } else {
                                            colorTerritory = colorTerritories.find(item => option.Franchise.Id === item.Id).Color;
                                        }

                                        styleOptions = {
                                            fillColor: colorTerritory,
                                            fillOpacity: 10,
                                            strokeColor: 'rgba(66, 66, 253, 0.9)',
                                            strokeOpacity: 1,
                                            strokeWeight: 1,
                                            clickable: true,
                                            draggable: false,
                                            editable: false,
                                            geodesic: false,
                                            zIndex: 9
                                        }
                                    }

                                    if(selectedOption && (selectedOption === 'heatMapAllAgents' || selectedOption === 'heatMapHomeSmartAgents')){
                                        styleOptions = optionsOutlined;
                                    }

                                    if(selectedOption && selectedOption === 'heatMapAllZipcodeAgents'){
                                        let colorTerritory = 'rgba(0, 0, 0, 0)'; // fallback transparent

                                        if(props.statistics){
                                            const matchingStat = props.statistics.find(
                                                s => s.ZipCode === option.Zipcode
                                            );
                                            
                                            if (matchingStat && matchingStat.AllAgentCount != null) {
                                                colorTerritory = getGreenShade(
                                                    matchingStat.AllAgentCount,
                                                    minAgentCount,
                                                    maxAgentCount
                                                );
                                            } else {
                                                colorTerritory = 'hsla(120, 100%, 50%, 0)';
                                            }
                                        }

                                        styleOptions = {
                                            fillColor: colorTerritory,
                                            fillOpacity: 10,
                                            strokeColor: 'rgba(66, 66, 253, 0.9)',
                                            strokeOpacity: 1,
                                            strokeWeight: 1,
                                            clickable: true,
                                            draggable: false,
                                            editable: false,
                                            geodesic: false,
                                            zIndex: 9
                                        }

                                    }
                                    
                                    if(selectedOption && selectedOption === 'heatMapShadedHomeSmartAgents'){
                                        let colorTerritory = 'rgba(0, 0, 0, 0)'; // fallback transparent

                                        if(props.statistics){
                                            const matchingStat = props.statistics.find(
                                                s => s.ZipCode === option.Zipcode
                                            );
                                            
                                            if (matchingStat && matchingStat.InHouseAgentCount != null) {
                                                colorTerritory = getGreenShade(
                                                    matchingStat.InHouseAgentCount,
                                                    minAgentHSCount,
                                                    maxAgentHSCount
                                                );
                                            } else {
                                                colorTerritory = 'hsla(120, 100%, 50%, 0)';
                                            }
                                        }

                                        styleOptions = {
                                            fillColor: colorTerritory,
                                            fillOpacity: 10,
                                            strokeColor: 'rgba(66, 66, 253, 0.9)',
                                            strokeOpacity: 1,
                                            strokeWeight: 1,
                                            clickable: true,
                                            draggable: false,
                                            editable: false,
                                            geodesic: false,
                                            zIndex: 9
                                        }

                                    }

                                    if(zipInfo && (zipInfo.name === option.Zipcode) ){
                                        styleOptions = optionsCurrent;
                                    } else if (zipsSelected && zipsSelected.some(item => option.Zipcode === item)){
                                        styleOptions = optionsSelected;
                                    }

                                    let polygeo = [];
                                    option.POLYGON.forEach((s, i) => {
                                        polygeo.push({ lat: +s[0], lng: +s[1] });
                                    });

                                    if(polygeo.length > 0){
                                        return <React.Fragment key={'polygroup_'+indexb}>
                                            {showZipcodeMarkers &&
                                                <Marker 
                                                    id={'marker_'+indexb+'_'+option.Zipcode}
                                                    key={'marker_'+indexb+'_'+option.Zipcode}
                                                    icon={"/assets/images/1x1-blank.png"}
                                                    label={option.Zipcode}
                                                    position={{ lat: option.centroid[0], lng: option.centroid[1] }}
                                                />
                                            }
                                            {(selectedOption && (selectedOption === 'heatMapAllAgents' || selectedOption === 'heatMapHomeSmartAgents' || selectedOption === 'heatMapShadedHomeSmartAgents' || selectedOption === 'heatMapAllZipcodeAgents')) &&
                                                <Polygon
                                                    id={'poly_'+indexb+'_'+option.Zipcode}
                                                    key={'poly_'+indexb+'_'+option.Zipcode}
                                                    label={option.Zipcode}
                                                    description={option.Franchise ? option.Franchise.InternalId : ''}
                                                    paths={polygeo}
                                                    options={styleOptions}
                                                    onClick={onPolyHeatClick.bind(this,option)}
                                                />
                                            }

                                            {(!selectedOption || (selectedOption && selectedOption === 'colorCodeTerritories')) &&
                                                <Polygon
                                                    id={'poly_'+indexb+'_'+option.Zipcode}
                                                    key={'poly_'+indexb+'_'+option.Zipcode}
                                                    label={option.Zipcode}
                                                    description={option.Franchise ? option.Franchise.InternalId : ''}
                                                    paths={polygeo}
                                                    options={styleOptions}
                                                    onClick={onPolyClick.bind(this, option)}
                                                />
                                            }

                                        </React.Fragment>  
                                    }
                                })
                            }
                        </GoogleMap>}
                    </div>
                </div>
            </Row>
        </>

        <Row style={{marginTop: '2rem'}}>                
            <div className="col-md-12">


                <Panel style={{padding: '2rem', border: (zipStatsAll && zipStatsAll.length > 0) ? '1px solid #ccc' : 'none'}}>
                    {selectedOption && selectedOption === 'colorCodeTerritories' && 
                        <div style={{marginBottom: '1rem'}}>
                            {colorTerritories && colorTerritories.length > 0 &&
                                colorTerritories.map((value, index) => {
                                    return <div key={'color_'+index} style={{ padding: '4px', background: value.Color, display: 'inline-block', margin: '4px' }}>{value.Name} </div>
                                })  
                            } 
                            {zipsSelected && zipsSelected.length > 0 &&
                                <hr/>
                            }
                        </div>
                    }
                    {zipsSelected && zipsSelected.length > 0 &&
                        <div>
                            <strong>Selected Zip Codes:</strong> {zipsSelected.join(",")}
                            <hr/>
                        </div>
                    }
                    {isBusy && 
                        <div style={{width: '100%',textAlign: 'center'}}><Spinner text="Loading Zip Code Stats..." /></div>
                    }
                    {(zipStatsAll && zipStatsAll.length > 0) &&
                        <Table responsive>
                            <thead>
                                <tr>
                                <th key={'Zip'}>Zip Code</th>
                                <th key={'Agent_Count'}>Agent Count</th>
                                <th key={'Selling_Units'}>Sold Units</th>
                                <th key={'Selling_Volume'}>Sold Volume</th>
                                <th key={'Selling_Average_Price'}>Average Sale Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    zipStatsAll.map((value, index) => {
                                        let current = '#fff';
                                        if(zipStats && value.zip === zipStats.zip){
                                            current = '#f3fccc'
                                        }
                                        if( zipsSelected.includes(value.zip)){
                                            return <tr key={'stat'+index} style={{backgroundColor: current}}>
                                                <td>{value.zip}</td>
                                                <td>{value.Agent_Count}</td>
                                                <td>{value.Selling_Units}</td>
                                                <td><CurrencyFormat value={value.Selling_Volume || 0.00} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true}/></td>
                                                <td><CurrencyFormat value={value.Selling_Average_Price || 0.00} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true}/></td>
                                            </tr>
                                        } else {
                                            return <></>
                                        }
                                    })
                                }
                                {totals && totals.totalRows > 0 && !isBusy && 
                                    <tr key='total_stats'>
                                        <td><strong>TOTALS</strong></td>
                                        <td><strong>{totals.totalAgentCount}</strong></td>
                                        <td><strong>{totals.totalSellingUnits}</strong></td>
                                        <td><strong><CurrencyFormat value={totals.totalSellingVolume || 0.00} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true}/></strong></td>
                                        <td><strong><CurrencyFormat value={totals.totalSellingAveragePrice || 0.00} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true}/></strong></td>
                                    </tr>
                                }
                            </tbody>
                        </Table>
                    }
                </Panel>
            </div>
        </Row>
        </>
    );
}
export default DynamicMap;
